function modal_mode_name(rows_key) {
  const mode_name = rows_key === 'register_rows' ? 'policy_modal_mode' : 'exception_modal_mode';
  return mode_name;
}

function should_update_existing_row(modal_mode, row_index, existing_row) {
  const should_update = modal_mode === 'edit' && row_index !== null && Boolean(existing_row);
  return should_update;
}

export function upsert_modal_row(context, rows_key, index_key, row) {
  const mode_name = modal_mode_name(rows_key);
  const rows = Reflect.get(context, rows_key);
  const row_index = Reflect.get(context, index_key);
  const modal_mode = Reflect.get(context, mode_name);
  const existing_row = Reflect.get(rows || [], row_index);
  if (should_update_existing_row(modal_mode, row_index, existing_row)) {
    context.$set(rows, row_index, row);
    return row;
  }
  rows.unshift(row);
  return row;
}
